import {
    StylesMap,
} from 'app/shared-components/GoogleMap/googleMap.types'

const getOptions = (theme: Record<string, any>): StylesMap[] => {
    return [
        {
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            elementType: 'labels.icon',
            stylers: [{
                visibility: 'off',
            }],
        },
        {
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[500],
            }],
        },
        {
            elementType: 'labels.text.stroke',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[300],
            }],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[50],
            }],
        },
        {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[400],
            }],
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.common.white,
            }],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[500],
            }],
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[400],
            }],
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[100],
            }],
        },
        {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[50],
            }],
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{
                color: theme.palette.secondary[300],
            }],
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{
                color: theme.palette.secondary[400],
            }],
        },
    ]
}

export default getOptions
